export type DepthModel = {
  id: string
  label: string
  hardware: string
  runtime: string
  input_size: number
  description: string
}

export type DepthModelCatalog = {
  models: DepthModel[]
  selected_model_id: string
}

export async function loadDepthModels() {
  const response = await fetch('/api/models/depth')
  if (!response.ok) throw new Error('Model catalog unavailable')
  return response.json() as Promise<DepthModelCatalog>
}

export async function selectDepthModel(modelID: string) {
  const response = await fetch('/api/models/depth/selection', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ model_id: modelID }),
  })
  if (!response.ok) throw new Error('Model selection rejected')
}
